export const setMetaTag = (attribute, name, content) => {
  if (!content) {
    return;
  }

  const selector = `meta[${attribute}="${name}"]`;
  let tag = document.head.querySelector(selector);

  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attribute, name);
    document.head.appendChild(tag);
  }

  tag.setAttribute('content', content);
};

export const setLinkTag = (rel, href) => {
  if (!href) {
    return;
  }

  const selector = `link[rel="${rel}"]`;
  let tag = document.head.querySelector(selector);

  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', rel);
    document.head.appendChild(tag);
  }

  tag.setAttribute('href', href);
};

export const setJsonLd = (id, data) => {
  if (!data) {
    return;
  }

  const selector = `script#${id}`;
  let tag = document.head.querySelector(selector);

  if (!tag) {
    tag = document.createElement('script');
    tag.setAttribute('id', id);
    tag.setAttribute('type', 'application/ld+json');
    document.head.appendChild(tag);
  }

  tag.textContent = JSON.stringify(data);
};
